/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".floating-toolbar[_ngcontent-%COMP%]{position:fixed;top:20px;left:20px;background:#fff;border:1px solid #ccc;padding:7px;border-radius:5px;display:flex;align-items:flex-start;flex-direction:row;align-items:flex-start;transition:width .2s ease;width:auto;z-index:25;max-width:360px}.content[_ngcontent-%COMP%]{margin-left:10px}.small-icon[_ngcontent-%COMP%]{font-size:16px}.small-toolbar-button[_ngcontent-%COMP%]{width:24px;height:24px;min-width:24px;padding:0;line-height:24px;align-self:flex-start}"];
export { styles as styles };
